import { baseAxios, errorHandler } from "../index";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import "jspdf-autotable";

export function getRekapOrder(dispatch) {
  baseAxios
    .get("/consumable/getOrder", {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then((respon) => {
      dispatch({ type: "SET_ORDERS", data: respon.data });
    })
    .catch(errorHandler);
}

export function getItemOrder(dispatch) {
  baseAxios
    .get("/consumable/getitems", {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then((respon) => {
      dispatch({ type: "SET_ITEMSORDER", data: respon.data });
    })
    .catch(errorHandler);
}
export function getKategoryCS(dispatch) {
  baseAxios
    .get("/consumable/getkategory", {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then((respon) => {
      dispatch({ type: "SET_KATEGORI", data: respon.data });
    })
    .catch(errorHandler);
}

export function pesanBarang(data) {
  Swal.fire({
    title: "Loading ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
  });
  baseAxios
    .post("/consumable/orderItem", data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then((respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}
export function getKpi1Consumable(dispatch, data) {
  baseAxios
    .get(`/consumable/getgrafik?dari=${data.dariTgl}&sampai=${data.smpTgl}`, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispatch({ type: "SET_KPI1CONSUMABLE", data: respon.data });
    })
    .catch(errorHandler);
}

export function importStock(data) {
  baseAxios
    .post(`/consumable/importexcelstock`, data, {
      headers: {
        token: localStorage.getItem("tokenjti"),
        "Content-Type": "multipart/form-data",
      },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function updateStatusOrder(data) {
  baseAxios
    .patch(`/consumable/updateOrder`, data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function getStockGudang(dispatch) {
  baseAxios
    .get("/consumable/getstockgudang", {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then((respon) => {
      dispatch({ type: "SET_STOCKGUDANG", data: respon.data });
    })
    .catch(errorHandler);
}

export function tambahStockGudang(data) {
  baseAxios
    .post(`/consumable/addstockgudang`, data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function pesanDariGudang(data) {
  Swal.fire({
    title: "Loading ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
  });
  baseAxios
    .post("/consumable/orderItemGudang", data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then((respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function getRekapOrderGudang(dispatch) {
  baseAxios
    .get("/consumable/getOrderGudang", {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then((respon) => {
      dispatch({ type: "SET_ORDERSGUDANG", data: respon.data });
    })
    .catch(errorHandler);
}

export function updateStatusOrderGudang(data) {
  baseAxios
    .patch(`/consumable/updateOrderGudang`, data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function getStockGudangLt(dispatch) {
  baseAxios
    .get("/consumable/getstockgudanglt", {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then((respon) => {
      dispatch({ type: "SET_STOCKGUDANGLT", data: respon.data });
    })
    .catch(errorHandler);
}

export function getBiaya(dispatch) {
  baseAxios
    .get("/consumable/getBiaya", {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then((respon) => {
      dispatch({ type: "SET_BIAYA", data: respon.data });
    })
    .catch(errorHandler);
}

export function downloadRekapOrder(data) {
  // var head = [["ID", "Country", "Rank", "Capital"]];
  // var body = [
  //   [1, "Denmark", 7.526, "Copenhagen"],
  //   [2, "Switzerland", 7.509, "Bern"],
  //   [3, "Iceland", 7.501, "Reykjavík"],
  //   [4, "Norway", 7.498, "Oslo"],
  //   [5, "Finland", 7.413, "Helsinki"],
  // ];

  // var doc = new jsPDF();
  // doc.autoTable({ head: head, body: body });
  // doc.output("dataurlnewwindow");
  // Swal.fire({
  //   title: "Tunggu ...",
  //   didOpen() {
  //     Swal.showLoading();
  //   },
  //   allowOutsideClick: false,
  //   allowEscapeKey: false,
  //   allowEnterKey: false,
  // });
  baseAxios
    .get("/consumable/getOrderDownload", {
      params: { idOrder: data.id },
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      var doc = new jsPDF();
      var head = [["Kode", "Nama Barang", "Jumlah", "Satuan", "Ceklist"]];
      var body = respon.data.map((val) => {
        return [val.kode, val.nama, val.Qty, val.satuan];
      });
      var before = `List Order ${data.kode}`;
      doc.text(before, 65, 20);
      doc.autoTable({ head: head, body: body, startY: 35 });
      let finalY = doc.lastAutoTable.finalY; // The y position on the page
      doc.setFontSize(12);
      doc.text(
        "..............., .......................20.....",
        135,
        finalY + 20
      );
      doc.text("Penerima", 40, finalY + 30);
      doc.text("(...................................)", 27, finalY + 60);
      doc.text("Pengirim", 160, finalY + 30);
      doc.text("(...................................)", 147, finalY + 60);
      doc.output("dataurlnewwindow");

      // doc.save("Document.pdf");
    })
    .catch(() => {
      console.log("gagal");
    });
}

export function downloadSuratJalan(data) {
  baseAxios
    .get("/consumable/getOrderDownload", {
      params: { idOrder: data.id },
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      var doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: [210, 148],
      });
      var head = [
        ["No", "Macam surat-surat/Barang", "Banyaknya", "Keterangan"],
      ];
      // var body = respon.data.map((val, index) => {
      //   return [index + 1, data.kode, val.Qty, val.satuan];
      // });
      var body = [["1", data.kode, "1", "Data Terlampir"]];
      var image =
        "data:image/jpeg;base64,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";
      doc.addImage(image, "JPEG", 50, 5, 20, 12);
      doc.text("PT. BINA AREA PERSADA", 75, 11);
      doc.setFontSize(5);
      doc.text(
        "TRADING,GENERAL CONTRACTOR,LABOUR SUPLIER & BUILDING MAINTENANCE",
        75,
        14
      );
      doc.setFontSize(10);
      doc.text("Kepada Yth.", 15, 25);
      doc.text("................................................", 15, 33);
      doc.text("................................................", 15, 39);
      doc.text("................................................", 15, 45);
      doc.text(
        "Surat Pengantar No. ............................................",
        120,
        25
      );
      doc.text("Tgl. ............................................", 146, 33);
      doc.autoTable({ head: head, body: body, startY: 49 });
      let finalY = doc.lastAutoTable.finalY; // The y position on the page
      doc.setFontSize(12);
      doc.text("Penerima", 40, finalY + 30);
      doc.text("(...................................)", 27, finalY + 60);
      doc.text("Pengirim", 160, finalY + 30);

      doc.text("(...................................)", 147, finalY + 60);
      doc.output("dataurlnewwindow");

      // doc.save("Document.pdf");
    })
    .catch((e) => {
      console.log(e);
    });
}
